import styled from "@emotion/styled";

import { sizeToken } from "../ThemeProvider/CandyTheme/ThemeBuilder/ICandyTheme";
import { theme } from "../ThemeProvider/CandyTheme/ThemeShorthand";

export const PathItem = styled.div(props => ({
    padding: theme(props).size([1, 0]),
    fontFamily: theme(props).typography.fontFamily.monospace,
    fontSize: "14px",
    borderBottom: theme(props).border.solid,
    display: "flex",
    justifyContent: "stretch",
    alignItems: "baseline",

    ":last-of-type": {
        border: 0,
    },
}));

export const Path = styled.span(props => ({
    flexGrow: 1,
    flexShrink: 0,
    color: props.theme.candy.typography.primary.color,
}));

export const PathValue = styled.span(props => ({
    ...props.theme.candy.typography.secondary.css(),
    ...props.theme.candy.typography.smallFont.css(),
    marginLeft: sizeToken(0.5),
}));

export const PathHighlightedText = styled.span({
    fontWeight: 700,
});

export const ControlName = styled.span(props => ({
    marginLeft: sizeToken(0.5),
    flexGrow: 0,
    flexShrink: 1,
    ...props.theme.candy.typography.smallFont.css(),
}));

export const Actions = styled.span(props => ({
    marginLeft: sizeToken(0.5),
    flexGrow: 0,
    flexShrink: 1,
    ...props.theme.candy.typography.smallFont.css(),
}));
